import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=009b44f8&scoped=true"
import script from "./orderPay.vue?vue&type=script&lang=ts"
export * from "./orderPay.vue?vue&type=script&lang=ts"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=009b44f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b44f8",
  null
  
)

export default component.exports